
import Vue from "vue";
export default Vue.extend({
	props: {
		label: String,
		value: [String, Number, Boolean]
	}
});
